import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import './global.css'

// import * as Sentry from "@sentry/react";

// Sentry.init({
//     dsn: "https://80ed95f05720ce661169d6e4d09f53de@o4507775069061120.ingest.us.sentry.io/4507775610978304",
//     integrations: [
//         Sentry.browserTracingIntegration(),
//         Sentry.replayIntegration(),
//     ],
//     // Tracing
//     tracesSampleRate: 1.0, //  Capture 100% of the transactions
//     // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
//     tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
//     // Session Replay
//     replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
//     replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
// });

window.API_URL = import.meta.env.VITE_API_URL;

const HEALTHCHECK_TIMEOUT_MS = 2000;

let appLoaded = false;

// RouterComponent (and its store/API modules, which read window.API_URL when they're
// created) must only be loaded *after* window.API_URL is assigned. Static imports are
// hoisted and evaluated before this file's own top-level code, so importing it eagerly
// above would capture window.API_URL as undefined. A dynamic import defers evaluation
// until after the health check below has resolved (or timed out).
function loadApp() {
    if (appLoaded) return;
    appLoaded = true;

    import("@/RouterComponent.tsx").then(({default: RouterComponent}) => {
        ReactDOM.createRoot(document.getElementById('root')!).render(
            <React.StrictMode>
                <RouterComponent/>
            </React.StrictMode>,
        )
    });
}

// Some devices block the primary API host in ways that don't cleanly reject the
// fetch (silently dropped packets, captive portals, missing/broken AbortController
// support, etc.). Wrapping everything defensively and adding an independent
// safety-net timer guarantees the app always loads - using the fallback URL if the
// health check didn't succeed/complete in time - instead of getting stuck forever
// on the static index.html placeholder.
try {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), HEALTHCHECK_TIMEOUT_MS);

    fetch(window.API_URL + "/LBHealthcheck/", {
        method: "GET",
        signal: controller.signal,
    })
        .catch(() => {
            window.API_URL = import.meta.env.VITE_API_URL_FALLBACK;
        })
        .finally(() => {
            clearTimeout(timeoutId);
            loadApp();
        });
} catch {
    window.API_URL = import.meta.env.VITE_API_URL_FALLBACK;
    loadApp();
}

// Hard safety net: no matter what happens above (hung promise that never
// settles, unsupported APIs, etc.), make sure the app renders.
setTimeout(() => {
    if (!appLoaded) {
        window.API_URL = import.meta.env.VITE_API_URL_FALLBACK;
    }
    loadApp();
}, HEALTHCHECK_TIMEOUT_MS + 1000);
